<template>
    <div class="dialog draggable-item bg-light light w-100-sm w-100-md w-75-lg  w-50-xl h-75" id="group_dialog" v-if="group" v-cloak>
        <div class="dialog-title pl-10">
            {{ isNew ? $t('Create New Group') : group.name }}
            <span class="button square closer" @click="$root.$emit('CLOSEGROUPVIEWDIALOG')"></span>
        </div>
        <div class="dialog-content overflow bg-light">
            <div id="profile">
                <div class="form-group">
                    <label>{{ $t("Customer") }}*</label>
                    <select class="input" v-model="group.id_customer" :disabled="customerLocked">
                        <option :value="null">{{ $t("None") }}</option>
                        <option v-for="c in customers" :value="c.id" :key="c.id">{{ c.company_name }}</option>
                    </select>
                    <small v-if="customerLocked" class="text-muted">{{ $t("Customer cannot be changed once set.") }}</small>
                </div>
                
                <div class="form-group">
                    <label>{{ $t("Name") }}*</label>
                    <input data-role="input" class="input" required v-model="group.name" type="text" />

                </div>

                <div class="form-group">
                    <div>
                        <label>{{ $t("Description") }}</label>
                        <input data-role="input" maxlength="255" class="input small" v-model="group.notes" type="text" />
                    </div>
                </div>

                <div class="form-group">
                    <label>{{ $t("Users") }}</label>
                    <select data-role="select" data-cls-selected-item="bg-light border pr-2 rounded" data-cls-selected-item-remover="bg-transparent border-0 d-flex flex-align-center" data-filter="false" class="input" multiple id="userselect" name="ids_users" required>
                        <option :selected="group.users.find(elem => elem.id == user.id || elem.id_user == user.id)" v-for="user in users" :value="user.id" :key="user.id" :title="user.role == 'Admin' ? $t('Admin') : $t('User')" :data-template="buildUserDataTemplate(user)">
                            <span>{{ user.username }}</span>
                        </option>
                    </select>
                    <small v-if="group.id == null" class="text-muted">{{ $t("Administrators will be added automatically") }}</small>
                </div>

                <div class="form-group">
                    <label>{{ $t("Devices") }}</label>
                    <select v-if="computers" class="input" data-role="select" :data-filter-placeholder="$t('Search for computers')" data-cls-selected-item="bg-light border pr-2 rounded" data-cls-selected-item-remover="bg-transparent border-0 d-flex flex-align-center" data-filter="true" multiple id="computerselect" name="ids_computers">
                        <option :selected="group.computers.find(elem => elem.id == pc.id)" v-for="pc in computers" :value="pc.id" :key="pc.id">
                            {{ pc.pc_name }} <label v-if="pc.organization_name != ''">({{ pc.organization_name }})</label> </option>
                    </select>
                </div>

                <div class="row">

                    <div class="form-group col-6 ">
                        <div>
                            <label>{{ $t("Email") }}</label>
                            <input data-role="input" class="input" v-model="group.email" type="email" data-prepend="<span class='mif-mail'></span>" />
                        </div>
                    </div>
                    <div class="form-group col-6">
                        <div>
                            <label>{{ $t("Phone Number") }}</label>
                            <input data-role="input" class="input" v-model="group.phone_number" type="number" v-number data-prepend="<span class='mif-phone'></span>" />
                        </div>
                    </div>
                </div>
                <div class="row">

                    <div class="form-group col-6 ">
                        <div>
                            <label>{{ $t("Address") }}</label>
                            <input data-role="input" class="input" v-model="group.address" type="text" data-prepend="<span class='mif-home'></span>" />
                        </div>
                    </div>

                </div>

            </div>
        </div>
        <div class="dialog-actions">
            <ClientMessageView :commands="['groupmethods']" />
            <button v-if="group.name != 'Shared Computers' && !isNew && group.attribute != 3" class="button secondary ml-2" @click="deleteGroup">{{ $t("Delete") }}</button>
            <button class="button secondary" @click="save" :disabled="[null, ''].includes(group.name)" v-disable-tooltip="$t('Insert group name')">{{ isNew ? $t('Create') : $t("Save") }}</button>
            <button class="button ml-2" @click="$root.$emit('CLOSEGROUPVIEWDIALOG')">{{ $t("Close") }}</button>
        </div>
    </div>
</template>
<script>
import $ from 'jquery';
import { draggableMixin } from '../../../mixins/draggable-mixin'
import ClientMessageView from './ClientMessageView.vue';
import { deleteGroup } from '../../../utils/entityMethods/group';
import { populateUsefulMaps } from '../../../utils/entityMethods/ticket.js';
export default {
    mixins: [draggableMixin],
    name: "GroupDialog",
    components: {
        ClientMessageView
    },
    data() {
        return {
            computers: null,
            users: null,
            customers: [],
            originalIdCustomer: null
        }
    },
    computed: {
        enableSave() {
            if (this.group == null || this.group.name == "") return false;
            // Il cliente è obbligatorio solo quando ticketing/fatturazione è abilitato.
            if (this.$root.ticketingEnabled && this.group.id_customer == "") return false;
            return true;
        },
        isNew() {
            return this.group == null || this.group.id == null;
        },
        customerLocked() {
            // In modifica, se id_customer era già popolato all'apertura, blocca la modifica
            return !this.isNew && !!this.originalIdCustomer;
        }
    },
    props: {

        group: {
            type: Object,
            required: false
        },

    },
    async created() {
        this.$session.setRoomPC(null);
        this.$root.socket("SETPC", null);
        await this.populateUsefulMaps();
        this.computers = Object.values(this.$root.pcMap);
        this.users = Object.values(this.$root.userMap);
        if (this.group.id == null) {
            this.users.removeIf(u => u.role == 'Admin')
        }
        this.originalIdCustomer = this.group.id_customer || null;
        this.customers = Object.values(this.$root.customerMap);
    },
    methods: {
        populateUsefulMaps,

        async save() {
            this.group.ids_computers = window.Metro.getPlugin($("#computerselect"), 'select').val();
            this.group.ids_users = window.Metro.getPlugin($('#userselect'), 'select').val();

            var newGroup = this.group.id == null ? await this.$api.createGroup(this.group) : await this.$api.editGroup(this.group);


            if (newGroup == null) {
                return;
            }

            this.$root.$emit('refreshGroups');
            this.$root.$emit('CLOSEGROUPVIEWDIALOG');

        },

        deleteGroup,

        buildUserDataTemplate(user) {
            var template = "<div>";
            if (user.role == "Admin") {
                template += "<img src='/assets/img/icons/admin.svg' width='20' style='vertical-align: middle;' title='" + this.$t(user.role) + "' class='mr-1'/>";
            } else {
                template += "<img src='/assets/img/icons/user.svg' width='18' style='vertical-align: middle;' title='" + this.$t(user.role) + "' class='mr-1'/>";
            }
            template += "<span>" + user.username + "</span>";

            template += "</div>";
            return template;
        }

    }
}
</script>